import React, { Fragment, FunctionComponent } from 'react';
import "./error.scss"
import Text from '../../components/typography/typgraphy';

const CommonError: FunctionComponent = () => {
  return (
    <Fragment>
      <Text className="error-description">Something went wrong!</Text>
      <Text className="error-description">Please re initiate the transaction from partner portal and try again.</Text>
    </Fragment>
  )
}

export default CommonError;
